module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.2ae7953270f2546f8b4a.js");
};